import React from 'react';
import { 
  Grid, 
  FormControlLabel, 
  Checkbox, 
  TextField, 
  Button, 
  Box, 
  Typography, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  ListSubheader,
  FormHelperText
} from '@mui/material';
import { doctorGroups } from '../constants/options';

const ApprovalSection = ({ formData, handleChange, handleNameChange, handleSignatureOpen, handleBlur, errors }) => {
  return (
    <Box sx={{ mt: 3, pt: 3, borderTop: '2px solid #008080' }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Final Approval & Signature
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={<Checkbox name="final_physician_approval" checked={formData.final_physician_approval} onChange={handleChange} />}
            label="Final Physician Approval"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth error={!!errors.doctor_name}>
            <InputLabel id="doctor-name-label">
              Name (Physician) <span style={{ color: 'red' }}>*</span>
            </InputLabel>
            <Select
              labelId="doctor-name-label"
              label="Name (Physician) *"
              name="doctor_name"
              value={formData.doctor_name || ""}
              onChange={handleNameChange}
              onBlur={handleBlur}
            >
              <MenuItem value=""><em>Select Doctor</em></MenuItem>
              {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                ...doctors.map((doctor, idx) => (
                  <MenuItem key={idx} value={doctor}>{doctor}</MenuItem>
                ))
              ])}
            </Select>
            <FormHelperText>{errors.doctor_name || ' '}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
            <Button
              variant="outlined"
              onClick={() => handleSignatureOpen('doctor_signature')}
              sx={{ color: '#008080', borderColor: '#008080' }}
            >
              {formData.doctor_signature ? 'Update Signature' : 'Provide Digital Signature'}
            </Button>
            {formData.doctor_signature && (
              <Box sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1 }}>
                <img
                  src={`data:image/png;base64,${formData.doctor_signature}`}
                  alt="Doctor Signature"
                  style={{ maxHeight: '100px' }}
                />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApprovalSection;
